import type { SVGProps } from "react";
export interface StoryAddIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function StoryAddIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: StoryAddIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M14.662 20.466a1.126 1.126 0 0 1 .676 2.147c-1.52.479-3.146.633-4.764.424l-.693-.113-.113-.028a1.126 1.126 0 0 1 .428-2.197l.114.016.551.09a8.9 8.9 0 0 0 3.801-.34Zm-11.58-3.8a1.125 1.125 0 0 1 1.492.21l.07.092.252.354a9 9 0 0 0 1.849 1.831l.357.25.094.068a1.126 1.126 0 0 1-1.238 1.866l-.098-.058-.448-.314a11.2 11.2 0 0 1-2.315-2.292l-.316-.444-.06-.1a1.125 1.125 0 0 1 .36-1.463Zm17.793-4.665a8.875 8.875 0 0 0-8.419-8.864L12 3.125l-.114-.006A1.126 1.126 0 0 1 12 .875l.573.015C18.45 1.187 23.125 6.048 23.125 12c0 3.384-1.512 6.416-3.894 8.454a1.126 1.126 0 0 1-1.463-1.71 8.85 8.85 0 0 0 3.107-6.743M2.225 9.597c.616.079 1.051.643.972 1.26a9.1 9.1 0 0 0 .043 2.56l.064.362.018.114a1.125 1.125 0 0 1-2.195.44l-.029-.112-.08-.45a11.4 11.4 0 0 1-.053-3.202 1.126 1.126 0 0 1 1.26-.972m2.08-2.023A1.125 1.125 0 1 1 2.356 6.45zm-.682-2.895a1.126 1.126 0 0 1 1.695 1.48 9 9 0 0 0-1.013 1.415L3.33 7.01l-.974-.56c.358-.62.78-1.214 1.267-1.772Zm4.141-2.962a1.125 1.125 0 0 1 .768 2.113l-.49.225A1.126 1.126 0 0 1 7.038 2.04q.303-.15.617-.283l.108-.04Z"
      />
      <path
        fill={color}
        d="M10.876 16v-2.874H8a1.125 1.125 0 0 1 0-2.25h2.876V8a1.125 1.125 0 0 1 2.25 0v2.876h2.873l.116.005a1.125 1.125 0 0 1 0 2.239l-.115.006h-2.874v2.873a1.125 1.125 0 0 1-2.25 0Z"
      />
    </svg>
  );
}
